export const APPLICATION_ID = 'cdf-ui-interactive-diagrams';
